module.exports = __webpack_public_path__ + "./img/Spear_v06_SpearBG.a8c1c39b06800bdbdf7257cd37292952.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/SpearGauge/images/Spear_v06_SpearBG.png
// module id = ./src/components/SpearGauge/images/Spear_v06_SpearBG.png
// module chunks = 0